import React from 'react'
import { Card, CardBody } from '../other/card/card';
import { useGetTopRemovalsServicesQuery, useGetTodayThisMonthRemovalsQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice';
import ComponentLoader from '../other/ComponentLoader';

const serviceColorLookup = {
    'google': '#4285F4',
    'ugc-source': '#F4A400',
    'telegram': '#229ED9',
    'ok.ru': '#F97400',
    'dailymotion': '#0073DC',
    'bing': '#008373',
    'vimeo': '#1AB7EA',
};

const formatServiceName = (key) =>
    key.split(/[-.]/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

const TopRemovals = ({ campaignId } = {}) => {
    const params = campaignId ? { campaign_id: campaignId } : undefined;
    const { data, isFetching } = useGetTopRemovalsServicesQuery(params);
    const { data: statsData } = useGetTodayThisMonthRemovalsQuery(params);

    return (
        <div className="flex-1">
            <Card style={{ height: "450px" }}>
                <CardBody className={"relative p-0 h-full flex flex-col"}>
                    {isFetching ? <ComponentLoader /> : null}
                    <div className='p-4 flex flex-col h-full'>
                        <div className="d-flex flex-wrap flex-shrink-0">
                            <div className="ms-2">
                                <h5 className="card-title mb-3">Top Removals For The Current Year</h5>
                            </div>
                        </div>
                        <div className="flex justify-around text-center flex-shrink-0 mb-3">
                            <div>
                                <p className="mb-1 text-sm opacity-70">Today</p>
                                <h5 className="mb-0">{statsData?.today?.toLocaleString() ?? '—'}</h5>
                            </div>
                            <div>
                                <p className="mb-1 text-sm opacity-70">This Month</p>
                                <h5 className="mb-0">{statsData?.this_month?.toLocaleString() ?? '—'}</h5>
                            </div>
                        </div>
                        <hr className="flex-shrink-0 my-0 mb-2" />
                        <div className="overflow-y-auto flex-1">
                            {data && Object.keys(data).length === 0 ? (
                                <div className="flex items-center justify-center h-full text-inverse text-opacity-50">
                                    No data to show
                                </div>
                            ) : (
                                <ul className="list-group list-group-flush">
                                    {data ?
                                        Object.entries(data).map(([service, value]) => (
                                            <li className="list-group-item" key={service}>
                                                <div className="py-2">
                                                    <h5 className="font-size-14">
                                                        {formatServiceName(service)} <span className="float-end">{value}%</span>
                                                    </h5>
                                                    <div className="progress animated-progess progress-sm">
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{ width: `${value}%`, backgroundColor: serviceColorLookup[service] || '#66BC0F' }}
                                                            aria-valuenow={value}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        )) : Array(5).fill(0).map((_, i) => (
                                            <li className="list-group-item" key={i}>
                                                <div className="py-2">
                                                    <div className="progress animated-progess progress-sm">
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{ width: `${(5 - i) * 12}%`, backgroundColor: '#66BC0F' }}
                                                            aria-valuenow={50}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default TopRemovals
